<app-header></app-header>
<app-left-nav></app-left-nav>
<div class="main-container">
  <div id="main-content">
    <router-outlet></router-outlet>
  </div>
<app-footer></app-footer>
</div>
